import { useState, useEffect } from 'react';

/**
 * AnimatedContent - Wrapper avec animation d'entrée (slide de droite à gauche)
 * A utiliser pour animer le contenu sous le header/filtre de chaque page.
 */
function AnimatedContent({ children }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Double rAF pour garantir que le navigateur a peint l'état initial avant la transition
    const id = requestAnimationFrame(() => {
      requestAnimationFrame(() => setVisible(true));
    });
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div style={{
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateX(0)' : 'translateX(40px)',
      transition: 'opacity 0.35s ease-out, transform 0.35s ease-out'
    }}>
      {children}
    </div>
  );
}

export default AnimatedContent;
